const wrapper = "_35sw66bzhb";

export { wrapper };
import "./organism.input-container.style.linaria.module.css";
//# sourceMappingURL=organism.input-container.style.js.map
